import { render, staticRenderFns } from "./EditProject.vue?vue&type=template&id=56e0eb24&scoped=true&"
import script from "./EditProject.vue?vue&type=script&lang=js&"
export * from "./EditProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0eb24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e0eb24')) {
      api.createRecord('56e0eb24', component.options)
    } else {
      api.reload('56e0eb24', component.options)
    }
    module.hot.accept("./EditProject.vue?vue&type=template&id=56e0eb24&scoped=true&", function () {
      api.rerender('56e0eb24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/ProjectsPage/EditProject.vue"
export default component.exports